import deviceMenu from '@js/common/deviceMenu.js';
import { initAOS } from '@js/common/aos.js';
import { appendSVGBtn, headeraddClass } from '@js/common/customFunctions.js';

deviceMenu();
headeraddClass();
initAOS();
/* Script on ready
------------------------------------------------------------------------------*/
document.addEventListener('DOMContentLoaded', () => {
    /* Process buttons */
    document
        .querySelectorAll('.btn-link, .btn-play')
        .forEach(function(element) {
            if (element.classList.contains('btn-link')) {
                appendSVGBtn(element, '#icon-right-arrow', '20', '16');
            } else if (element.classList.contains('btn-play')) {
                appendSVGBtn(element, '#icon-play-btn', '26', '43');
            }
        });
    /* Process buttons End */

    document.querySelectorAll('nav > ul > li > a').forEach(function(link) {
        const text = link.textContent.trim();
        link.setAttribute('data-title', text);
    });

    /* Show search bar on click start */
    const searchButton = document.querySelector(
        'header.main-header .header-search .header-search-btn',
    );
    const searchWrap = searchButton.parentNode.querySelector('.h-search-wrap');
    const body = document.body;

    searchButton.addEventListener('click', function() {
        this.classList.toggle('is-click');
        searchWrap.classList.toggle('is-open');
        body.classList.toggle('scroll-fixed');

        setTimeout(() => {
            const searchInput = this.parentElement.querySelector(
                'input[type="search"]',
            );
            if (searchInput) {
                searchInput.focus();
            }
        }, 100);
    });

    // Hide search bar on click
    const overlay = document.querySelector(
        'header.main-header .header-search .h-search-overlay',
    );
    const closeButton = document.querySelector(
        'header.main-header .header-search .h-search-close',
    );

    function closeSearchPanel() {
        searchButton.classList.remove('is-click');
        searchWrap.classList.remove('is-open');
        body.classList.remove('scroll-fixed');
    }

    if (overlay) {
        overlay.addEventListener('click', closeSearchPanel);
    }
    if (closeButton) {
        closeButton.addEventListener('click', closeSearchPanel);
    }
    /* Show search bar on click end */


    /* Menu link Change # to javascript:void(0) */
    document.querySelectorAll(
        'header.main-header ul li a[href="#"], footer.main-footer ul li a[href="#"]',
    ).forEach(link => {
        link.setAttribute('href', 'javascript:void(0);');
    });
});

/* Use jQuery code Start
------------------------------------------------------------------------------*/

(function($) {
    // Write code here
    jQuery('.error404,.main-content,header ').css(
        '--HeaderHeight',
        $('.main-header').outerHeight() + 'px',
    );

    /* Social Icon Start*/
    document.querySelectorAll('a').forEach(function(element) {
        if (element.classList.contains('heateor_sss_button_linkedin')) {
            appendSVGBtn(element, '#icon-linkedin', '22', '22');
        } else if (element.classList.contains('heateor_sss_button_x')) {
            appendSVGBtn(element, '#icon-twitter', '20', '19');
        } else if (element.classList.contains('heateor_sss_facebook')) {
            appendSVGBtn(element, '#icon-facebook', '11', '22');
        } else if (element.classList.contains('heateor_sss_more')) {
            appendSVGBtn(element, '#icon-share', '16', '23');
        }
    });

    // /* Table Wrapper */
    // $(
    //     '.wysiwyg-component table , .post-detail-block .pdb-desc table , .wysiwyg-component  table',
    // ).wrap('<div class=\'table-wrapper\'><span class=\'h3\'></span></div>');
    // /* Table Wrapper End */
})(jQuery);

/* ------------------------------------------------------------------------------
Use jQuery code End */

document.addEventListener('DOMContentLoaded', function() {
    const banner = document.querySelector('.mh-banner');
    if (!banner) {
        return;
    }

    const closeBtn = banner.querySelector('.mh-innerbanner > svg');
    const root = document.documentElement;

    // Check if banner is already closed
    const bannerClosed = document.cookie.includes('banner_closed=true');
    if (bannerClosed) {
        banner.style.display = 'none';
        root.style.setProperty('--BannerOffset', '0rem');
        return;
    }

    // Close button click
    closeBtn.addEventListener('click', () => {
        banner.style.display = 'none';
        root.style.setProperty('--BannerOffset', '0rem');

        const expiry = new Date();
        expiry.setDate(expiry.getDate() + 30);

        document.cookie = `banner_closed=true; expires=${expiry.toUTCString()}; path=/`;
    });
});

/* TABLE RESPONSIVE SCRIPT WITH RESIZE SUPPORT */
function wrapTables() {
    document
        .querySelectorAll(
            '.wysiwyg-component table, .post-detail-block table',
        )
        .forEach(function(table) {
            if (!table.parentElement.classList.contains('table-wrapper')) {
                const wrapper = document.createElement('div');
                wrapper.className = 'table-wrapper';
                table.parentNode.insertBefore(wrapper, table);
                wrapper.appendChild(table);
            }
        });
}

function buildMobileTableView(wrapper) {
    const table = wrapper.querySelector('table');
    if (!table || wrapper.querySelector('.mobile-table-view')) {return;}

    const rows = table.querySelectorAll('tbody tr');
    if (rows.length === 0) {return;}

    const numColumns = rows[0].children.length;
    const columns = Array.from({ length: numColumns }, () => []);

    rows.forEach((row, rowIndex) => {
        Array.from(row.children).forEach((cell, colIndex) => {
            columns[colIndex].push({
                isHeader: rowIndex === 0,
                content: cell.innerHTML.trim(),
            });
        });
    });

    const mobileView = document.createElement('div');
    mobileView.className = 'mobile-table-view';

    columns.forEach((colData) => {
        const colBlock = document.createElement('div');
        colBlock.className = 'column-block';

        colData.forEach((cell, index) => {
            const div = document.createElement('div');
            div.className = cell.isHeader ? 'column-header' : 'column-cell';
            div.innerHTML = cell.content;
            colBlock.appendChild(div);
        });

        mobileView.appendChild(colBlock);
    });

    table.insertAdjacentElement('afterend', mobileView);
}

function handleResponsiveTables() {
    wrapTables();

    document.querySelectorAll('.table-wrapper').forEach((wrapper) => {
        const isMobile = window.innerWidth <= 992;
        const hasMobileView = wrapper.querySelector('.mobile-table-view');

        if (isMobile && !hasMobileView) {
            buildMobileTableView(wrapper);
        }

        if (!isMobile && hasMobileView) {
            wrapper.querySelector('.mobile-table-view').remove();
        }
    });
}

window.addEventListener('DOMContentLoaded', handleResponsiveTables);
window.addEventListener('resize', () => {
    clearTimeout(window._tableResizeTimeout);
    window._tableResizeTimeout = setTimeout(handleResponsiveTables, 200);
});
/* TABLE RESPONSIVE SCRIPT WITH RESIZE SUPPORT */
